<template>
  <div class="irp-opportunities-tab" data-testid="irp-opportunities-tab">
    <template v-if="!hasError">
      <h3 class="irp-opportunities-tab__heading">Opportunity information</h3>
      <div :class="{ 'irp-opportunities-tab__card': hasOwnOpportunities }">
        <div
          v-if="isInitialLoading"
          class="irp-opportunities-tab__skeleton"
          data-testid="irp-opportunities-tab-skeleton"
        >
          <BittsBone v-for="row in SKELETON_ROW_COUNT" :key="row" type="copy" />
        </div>
        <IRPOpportunityList
          v-else
          :opportunities="ownOpportunities"
          empty-message="No opportunities on this record"
        />
      </div>
    </template>

    <IRPPartnerDataSection
      :key="individualRecordStore.recordKey"
      section="opportunities"
    >
      <template #default="{ partner }">
        <div class="irp-opportunities-tab__card">
          <IRPOpportunityList :opportunities="partner.opportunities.items" />
        </div>
      </template>
    </IRPPartnerDataSection>
  </div>
</template>

<script setup lang="ts">
import { BittsBone } from '@crossbeam/bitts';

import { computed } from 'vue';

import { useIndividualRecordStore } from '@/stores';

import IRPOpportunityList from './IRPOpportunityList.vue';
import IRPPartnerDataSection from './IRPPartnerDataSection.vue';

const SKELETON_ROW_COUNT = 3;

const individualRecordStore = useIndividualRecordStore();

const isInitialLoading = computed(
  () =>
    !!individualRecordStore.opportunities?.isLoading &&
    !individualRecordStore.opportunities?.hasLoaded,
);

const hasError = computed(() => !!individualRecordStore.opportunities?.error);

const ownOpportunities = computed(
  () => individualRecordStore.opportunities?.own?.opportunities.items ?? [],
);

const hasOwnOpportunities = computed(
  () => isInitialLoading.value || !!ownOpportunities.value.length,
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-opportunities-tab {
  @apply flex flex-col gap-16;
}

.irp-opportunities-tab__heading {
  @apply text-base font-bold text-neutral-text-strong;
}

.irp-opportunities-tab__card {
  @apply rounded-16 border border-neutral-border bg-white py-24 pl-24 pr-16 shadow-component;
}

.irp-opportunities-tab__skeleton {
  @apply flex flex-col gap-16;
}
</style>
